import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import AppV4 from './AppV4.vue'
// import router from './router'
import {useRegistrationStore} from "@/stores/registration.ts";
import clickOutside from "@/directives/click-outside.ts";

const mountApp = () => {
    // V3 (and earlier) registration widget — mount on .company-registration elements
    document.querySelectorAll('.company-registration').forEach((parentElement) => {
        const rootProps = { ...(parentElement as HTMLElement).dataset };

        Object.keys(rootProps).forEach((key: string) => rootProps[key] = JSON.parse(rootProps[key] ?? ''));

        try {
            const app = createApp(App, rootProps);

            app.use(createPinia())
            // app.use(router)
            app.mount(parentElement);

            app.directive("click-outside", clickOutside);
        }
        catch (error) {
            console.error("Error mounting Vue app on", parent, ":", error);
        }
    });

    // V4 registration widget — mount on .company-registration-v4 elements
    // Embed with: <div class="company-registration-v4" data-origin="roofingcalculator"></div>
    document.querySelectorAll('.company-registration-v4').forEach((parentElement) => {
        const rootProps: Record<string, any> = { ...(parentElement as HTMLElement).dataset };

        Object.keys(rootProps).forEach((key: string) => {
            try {
                rootProps[key] = JSON.parse(rootProps[key] ?? '');
            } catch {
                // leave as plain string if not valid JSON (e.g. origin="roofingcalculator")
            }
        });

        try {
            const app = createApp(AppV4, rootProps);

            app.use(createPinia());
            app.mount(parentElement);

            app.directive("click-outside", clickOutside);
        }
        catch (error) {
            console.error("Error mounting V4 Vue app on", parentElement, ":", error);
        }
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => mountApp());
}
else {
    mountApp();
}


//@ts-ignore
window.initMap =  () => {
    useRegistrationStore().googleService.initialized = true;
}
